<section class="why" >
  <div class="why-text">
    <h1 class="header-txt">{{ "why.headline" | translate }}</h1>
  </div>
  <div class="info-container">
    <p class="lead">
      {{ "why.intro" | translate }}
    </p>
    <h2 class="title">{{ "why.title" | translate }}</h2>
    <ul class="badges">
      <li class="location-icon">
        <img class="base" src="assets/img/icons/about_me/location.svg" alt="" />
        <img
          class="hover"
          src="assets/img/icons/about_me/location_hover.svg"
          alt=""
        />
        <p>{{ "why.located" | translate }}</p>
      </li>
      <li class="remote-icon">
        <img src="assets/img/icons/about_me/remote.svg" alt="" />
        <p>{{ "why.remote" | translate }}</p>
      </li>
      <li class="relocation-icon">
        <img src="assets/img/icons/about_me/relocation.svg" alt="" />
        <p>{{ "why.relocate" | translate }}</p>
      </li>
    </ul>
    <div class="btn-pos">
      <a href="#contact" class="btn">{{ "why.contact_btn" | translate }}</a>
    </div>
  </div>
</section>

<img
  class="next-arrow"
  src="assets/img/icons/arrows/arrow_right.png"
  alt="Weiter"
  role="button"
  tabindex="0"
  (click)="onNext()"
  (keydown)="onKey($event)"
/>